"use strict";

/**
* Элемент списка объектов. 
* 
* @class WebAccess.components.wrappers.objectList.CustomWorkListItem
* @since 5.3.0.1010
* @extends ListItem
* @property {string} id ИД объекта
* @property {string} name Имя объекта
* @property {string} kind Тип объекта. Например, задача, задание, документ
* @param {string} itemSelector Существующий элемент списка
* @param {boolean} isTableItem Признак того, что текущий элемент является строкой таблицы
*/
(function (global) {

  var CustomWorkListItem = WebAccess.components.wrappers.objectList.ListItem.extend({
    /**
     * Удаляет у задания стиль непрочитанного задания.
     * @returns {WebAccess.components.wrappers.objectList.CustomWorkListItem} 
     */
    removeUnreadStyle: function () {
      this._jObject.removeClass('unread');
      return this;
    },
    /**
     * Добавляет к заданию стиль непрочитанного задания.
     * @returns {WebAccess.components.wrappers.objectList.CustomWorkListItem} 
     */
    addUnreadStyle: function () {
      this._jObject.addClass('unread');
      return this;
    },
    /**
     * Возвращает признак прочитанности задания.
     * @returns {boolean} 
     */
    isUnread: function () {
      return this._jObject.hasClass('unread');
    }
  });

  global.components.wrappers.objectList.CustomWorkListItem = CustomWorkListItem;
})(window.WebAccess);